import React, { useEffect, useState } from 'react';
import PostCatergoryForm from '@app/components/apps/PostCategories/PostCatergoryForm';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row } from 'antd';

const routes = [
  {
    path: '/post-categories',
    breadcrumbName: 'Post Categories',
  },
  {
    path: '/add-post-category',
    breadcrumbName: 'Add Post Category',
  },
];

const CreatePostCategories = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Post Category');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <PostCatergoryForm
        editable={true}
        pageTitle={'Create Post Category'}
        type={'create'}
        setCurrentBreadcrumName={setCurrentBreadcrumName}
        id={null}
      />
    </Row>
  );
};

export default CreatePostCategories;
